import { render, staticRenderFns } from "./SettingAdd.vue?vue&type=template&id=6125e3d8&scoped=true"
import script from "./SettingAdd.vue?vue&type=script&lang=js"
export * from "./SettingAdd.vue?vue&type=script&lang=js"
import style0 from "./SettingAdd.vue?vue&type=style&index=0&id=6125e3d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125e3d8",
  null
  
)

export default component.exports